import { ThunkType } from "../../../../core/store/reducers";
import updateTradingData from "../api/updateTradingData";
import { TradingData } from "../types";
import { setFetchState, invalidateTradingsData } from "../tradingDataSlice";

export const upsertTradingData = (tradingData: TradingData): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result =  await dispatch(updateTradingData(userId, tradingData))

  if (result && result.resCode === "OK") {
    dispatch(setFetchState({ type: "successful", result: result.resDesc }));
    dispatch(invalidateTradingsData());
    return result.resDesc;
  } else {
    dispatch(setFetchState({ type: "error", errorCode: result?.resCode }));
  }
};
